import React from 'react'
import HttpServices from '../../utils/Http.services'
import { checkTextTranslation, checkTranslation, getObject } from '../../utils/useful'

class TableSelectInput extends React.Component {
    state = {
        data: []
    }

    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    getLabel(key) {
       
        if (this.props.data) {
           

            let nData = getObject(this.props.fullData, 'populates.records')
            const seenIds = new Set();
           
            const filteredArray = nData.filter(item => {
                if (this.props.data.includes(item._id) && !seenIds.has(item._id)) {
                  seenIds.add(item._id);
                  return true;
                }
                return false;
              });
         
            return filteredArray?.map((element) => {
                if ((Array.isArray(this.props.data) && this.props.data.includes(element._id)) || (this.props.data && element._id == this.props.data)) {
                    return (
                        <div className="flexc mrd-1 mb-1" style={{ backgroundColor: this.state.data.colors?.background ?? '#f2f6f8', borderRadius: 20, padding: '6px 8px' }}>
                            <p className="text-smaller" style={{ color: this.state.data.colors?.color ?? '#051015', width: '100%', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{getObject(element, this.props.header?.information?.fields?.title)}</p>
                        </div>
                    )
                }
            })
            // } else {
            //     return getObject(nData, this.props.header?.information?.fields?.title)

            // }
        }
        // else {
        //     if (this.props.header?.information?.default) {
        //         for (let i = 0; i < this.props.header?.information?.items?.length; i++) {
        //             const item = this.props.header?.information?.items[i];
        //             if (item.value == this.props.header?.information?.default) {
        //                 return item[key]
        //             }
        //         }
        //     } else {
        //         return ' '
        //     }
        // }

    }
    spliter(source, string) {
        let stringArray = string.split('.')
        let finalString = source
        stringArray.forEach(element => {
            if (finalString) {
                finalString = finalString[element]
            }
        });
        return finalString
    }
    render() {
        // console.log('this.props.fullData',this.props.fullData)
        return (
            <div className="w-100 h-100 flexc sc-2" style={{ overflow: 'hidden' }}>
                {/* <p className="" style={{ color: this.getLabel("color") ? this.getLabel("color") : '', backgroundColor: this.getLabel("backgroundColor"), textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(this.getLabel("title"))}</p> */}
                {/* {console.log('Object.values(this.state.data)', Object.values(this.state.data))} */}
                {(this.props.data && this.props.data.length != 0) ? (
                    <div className={'flexc'} style={{}}>
                        {/* {console.log('this.props.datalok', this.props.data)} */}
                        {/* {this.state.data.map((prop, index) => { */}
                        {/* let value = this.spliter(prop, this.props.header?.information?.fields?.title)
                            return ( */}
                        {this.getLabel('title')}

                        {/* ) */}
                        {/* })} */}
                    </div>
                ) : ''}
            </div>
        )
    }
}

export default TableSelectInput;